import { Link } from 'react-router-dom';
import elsaLogo from '../assets/images/elsa-logo-black.svg';
import elsaloginpic from '../assets/images/elsa-login-pic.png';
import env from '../utils/env';

function UserPending() {
  const config = env();

  return (
    <div className="page-login">
      <div className="login-container">
        <div className="login-form">
          <div className="elsa-logo">
            <img src={elsaLogo} alt="Elsa Now" />
          </div>
          <h1 className="login-title">Chào mừng bạn đến với công cụ Affiliate của ELSA</h1>
          <div className="invalid-user">
            <div className="page-pending">
              <div className="alert alert-warning text-center" role="alert">Tài khoản cộng tác viên của bạn đang chờ phê duyệt</div>
              <p className="text-center">
                <a href={config.apiURL} className="common-btn">Quay lại trang chủ</a> hoặc <Link to="/login">đăng nhập</Link> với tài khoản khác
              </p>
            </div>
          </div>
        </div>
        <div className="login-background">
          <div></div>
          <div className="content">
            <img src={elsaloginpic} alt="" />
            <p className="title">
              ELSA SPEAK - APP HỌC NÓI TIẾNG ANH BẰNG A.I.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserPending;
